import { useLocalesState } from "../context/locales"
import { useQuery } from "@tanstack/react-query"

type Grade = {
    rating: number
    count: number
    distribution: {
        oneStar: number
        twoStars: number
        threeStars: number
        fourStars: number
        fiveStars: number
    }
    period: {
        start: string
        end: string
        calculatedAt: string
        firstConsideredReviewSubmission: string
        lastConsideredReviewSubmission: string
        ratingTrend: "NEUTRAL" | "POSITIVE" | "NEGATIVE"
    }
}

type TrustedShopsData = {
    grades: {
        "7days": Grade
        "30days": Grade
        "90days": Grade
        "365days": Grade
        overall: Omit<Grade, "period"> & {
            period: Omit<Grade["period"], "ratingTrend">
        }
    }
    syndicated: boolean
}

const TRUSTED_SHOPS_CHANNEL_ID = "chl-a651571a-c49f-4212-8f4a-bfba73bcf931"

const useQueryTrustedShops = () => {
    const { region, language } = useLocalesState()

    return useQuery<TrustedShopsData>({
        queryKey: ["getTrustedShops", { id: TRUSTED_SHOPS_CHANNEL_ID }],
        queryFn: ({ signal }) =>
            fetch(
                `https://integrations.etrusted.com/feeds/grades/v1/channels/${TRUSTED_SHOPS_CHANNEL_ID}/touchpoints/all/feed.json`,
                { signal }
            ).then(d => d.json()),
        enabled: language === "de" && region === "DE" && !!process.env.TRUSTED_SHOPS_ID,
        meta: { background: true },
    })
}

export { useQueryTrustedShops }
